import TopicsNav from './topicsNav';

const topicsNavConfig = {
  name: 'topicsNav',
  class: TopicsNav,
  querySelector: {
    controller: '.topics_nav-control',
    closeButton: '.topics_nav-close',
    openButton: '.topics_nav-burger',
    target: '.topics__nav-container',
  },
};

export default topicsNavConfig;
